/**
 * Adapts the page-size Select's string value to the numeric callback.
 *
 * Separate from `Pagination.tsx` so that file exports only a component (fast
 * refresh), and named rather than inline so the conversion is testable: Radix
 * Select speaks strings while the caller needs a number, and driving the widget
 * to invoke an inline handler needs a layout engine jsdom does not implement.
 */
export function pageSizeHandler(
  onPageSizeChange: (pageSize: number) => void,
): (value: string) => void {
  return (value: string): void => {
    onPageSizeChange(Number.parseInt(value, 10));
  };
}
